import React from 'react';
import PropTypes from 'prop-types';

import CopyButton from '../../shared/CopyButton';
import Mixpanel from '../../shared/Mixpanel';
import { useExportData } from './hooks';

const trackCopyClick = () => {
  Mixpanel.track('Copied RTB export from new/edit page');
};

const Export = ({ AdMarkupService, creative }) => {
  const { exportContent, rtbVersion } = useExportData(
    AdMarkupService,
    creative
  );

  if (exportContent) {
    return (
      <div
        className="pixel-row creative-tag-area p2 mb2 mt1"
        data-testid="rtb-export"
      >
        <div
          className={`pixel-row_pixel-url ${
            rtbVersion() === '2.2' ? 'creative-tag-markup' : ''
          }`}
        >
          {exportContent}
        </div>
        <CopyButton copyContent={exportContent} onClick={trackCopyClick} />
      </div>
    );
  } else {
    return null;
  }
};

Export.propTypes = {
  AdMarkupService: PropTypes.shape({ generate: PropTypes.func }).isRequired,
  creative: PropTypes.shape({
    headline: PropTypes.string.isRequired,
    dsp: PropTypes.shape({
      rtb_version: PropTypes.string.isRequired
    }),
    rtb_pixel: PropTypes.shape({
      pixel_key: PropTypes.string.isRequired
    })
  }).isRequired
};

export default Export;
